export default "__VITE_ASSET__C9IlF2ok__"